var map = {
	"./add-protocol.svg": 65935,
	"./bip-simple.svg": 55734,
	"./camera-web.svg": 8490,
	"./delete.svg": 86796,
	"./display.svg": 39726,
	"./download-black.svg": 87899,
	"./download.svg": 65272,
	"./duplicate.svg": 14502,
	"./edit-session-list.svg": 5446,
	"./export-to-doc.svg": 51682,
	"./lock-open.svg": 94459,
	"./lock.svg": 557,
	"./paper-plane-top-regular.svg": 95516,
	"./pen-to-square.svg": 16002,
	"./play.svg": 50385,
	"./record-vinyl.svg": 7595,
	"./rotate-left.svg": 37365,
	"./rotate-right.svg": 3542,
	"./save.svg": 45498,
	"./settings.svg": 41800,
	"./timer.svg": 58356,
	"./tooltip.svg": 35617,
	"./user-check-presence.svg": 98110,
	"./video-arrow-up-right.svg": 81484,
	"./wallet.svg": 65886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67383;